import './About.css';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';

export default function About() {
  return (
    <div className="about">
      <div className="about-photo">
        <img src="/pic3.JPG" alt="Erika Bou Khalil" />
      </div>

      <h1>About Me</h1>

      <section className="about-section">
        <h3>Success Story</h3>
        <p>
          I approach design with one clear principle: every visual element must serve a purpose.
          My background in graphic design and TV production shaped the way I think: strategy first, creativity second.
          I believe that strong design isn’t decoration; it’s communication. It clarifies a message and strengthens a brand.
        </p>
        <p>
          My work focuses on building clean and modern visual identities. I enjoy taking complex ideas and turning them into direct visuals.
          For me, a project is successful when it looks good and performs well.
        </p>
        <p>
          Over the years, I have worked with corporate businesses, musical events, sports events, and local initiatives,
          helping them elevate their presence and communicate more effectively.
        </p>
        <p>
          As I continue building my portfolio, my focus remains the same: producing thoughtful, high-quality design
          that helps brands grow, communicate, and stand out.
        </p>
      </section>

      <section className="about-section">
        <h3>Visual Design Contributions</h3>
        <div className="visual-list">
          <div className="visual-category">
            <h4>Posters</h4>
            <ul>
              <li>Murex D’or — 1 visual</li>
              <li>HIGHLANDER Lebanon — 3 visuals</li>
              <li>HIGHLANDER Saudi Arabia — 2 visuals</li>
              <li>Azure Beach Resort — 1 visual</li>
              <li>Christmas Village — 1 visual</li>
            </ul>
          </div>
          <div className="visual-category">
            <h4>Logo and Uplifting</h4>
            <ul>
              <li>Logo Uplifting — 5 visuals</li>
            </ul>
          </div>
          <div className="visual-category">
            <h4>Projects</h4>
            <ul>
              <li>Al Hamra Street — 3 visuals</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="about-links">
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=info@erikaboukhalil.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Email"
          >
          <FaEnvelope />
        </a>

        <a href="https://www.linkedin.com/in/erika-bou-khalil-65279a284" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
      </div>
    </div>
  );
}

